import React, { useState } from 'react';
import SupplyOrders from '../supplies/SupplyOrders';
import NewProducts from '../supplies/NewProducts';
import NewSuppliers from '../supplies/NewSuppliers';

const Dashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'orders' | 'new-products' | 'new-suppliers'>('orders');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'orders':
        return <SupplyOrders />;
      case 'new-products':
        return <NewProducts />;
      case 'new-suppliers':
        return <NewSuppliers />;
      default:
        return <SupplyOrders />;
    }
  };

  return (
    <div className="container-fluid">
      {/* Header */}
      <div className="row mb-4">
        <div className="col">
          <div className="dashboard-header rounded">
            <div className="container">
              <h2 className="mb-0">
                <i className="bi bi-cart3 me-3"></i>
                Purchase Management Dashboard
              </h2>
              <p className="mb-0 opacity-75">Manage supply orders and product catalog</p>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="row mb-4">
        <div className="col">
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <button 
                className={`nav-link ${activeTab === 'orders' ? 'active' : ''}`}
                onClick={() => setActiveTab('orders')}
              >
                <i className="bi bi-list-ul me-2"></i>
                Supply Orders
              </button>
            </li>
            <li className="nav-item">
              <button 
                className={`nav-link ${activeTab === 'new-products' ? 'active' : ''}`}
                onClick={() => setActiveTab('new-products')}
              >
                <i className="bi bi-box-seam me-2"></i>
                New Products
              </button>
            </li>
            <li className="nav-item">
              <button 
                className={`nav-link ${activeTab === 'new-suppliers' ? 'active' : ''}`}
                onClick={() => setActiveTab('new-suppliers')}
              >
                <i className="bi bi-truck me-2"></i>
                New Suppliers
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Tab Content */}
      <div className="row">
        <div className="col">
          <div className="fade-in">
            {renderTabContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
